export default __webpack_public_path__ + "static/FoundersGrotesk-Light-20ee6acc0714024eb990243f8885868b.woff";